module.exports = __webpack_public_path__ + "static/img/bg-search-persion.07278a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-search-persion.png
// module id = 820
// module chunks = 0